export default __webpack_public_path__ + "app/build/static/media/flag_gb.2d19fed4.svg";